/* Merme unified add-to-cart — one AJAX handler for every Merme add button
   (PDP + product cards), so the cart drawer always updates live.
   Tag a form with [data-merme-add-form]; a Buy-now button with [data-merme-buy-now]. */
(function () {
  function cartDrawer() { return document.querySelector('cart-drawer'); }
  function openOnAdd() {
    var d = cartDrawer();
    return !d || d.getAttribute('data-open-on-add') !== 'false';
  }
  // Update the cart drawer DOM from a /cart response WITHOUT opening it.
  function silentUpdate(res, d) {
    if (!d || !d.getSectionsToRender || !res.sections) return;
    d.getSectionsToRender().forEach(function (s) {
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (el && res.sections[s.id] != null) el.innerHTML = d.getSectionInnerHTML(res.sections[s.id], s.selector);
    });
    d.classList.remove('is-empty');
    var items = d.querySelector('cart-drawer-items'); if (items) items.classList.remove('is-empty');
  }
  // Apply a cart response: open the drawer or update silently, per the setting.
  function applyCart(res, d) {
    if (!d) { return; }
    if (openOnAdd() && d.renderContents) {
      d.renderContents(res);
      d.classList.remove('is-empty');
      var items = d.querySelector('cart-drawer-items'); if (items) items.classList.remove('is-empty');
    } else {
      silentUpdate(res, d);
    }
  }

  function updateHeaderCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-bb-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      }).catch(function () {});
  }

  function addFromForm(form) {
    var fd = new FormData(form);
    var id = fd.get('id');
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    if (!id) return Promise.reject();
    var item = { id: id, quantity: qty };
    // Line item properties (personalization etc.): properties[Name] inputs
    fd.forEach(function (val, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m) { (item.properties = item.properties || {})[m[1]] = val; }
    });
    var body = { items: [item] };
    var d = cartDrawer();
    if (d && d.getSectionsToRender) {
      body.sections = d.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }

  function flash(btn, ok) {
    if (!btn) return;
    var label = btn.querySelector('span') || btn;
    var orig = label.textContent;
    label.textContent = ok ? 'Added to cart ✓' : 'Try again';
    btn.classList.toggle('is-added', !!ok);
    setTimeout(function () { label.textContent = orig; btn.disabled = false; btn.classList.remove('is-added'); }, 1800);
  }

  /* Add to cart (any tagged form) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-merme-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    addFromForm(form).then(function (res) {
      updateHeaderCount();
      var d = cartDrawer();
      if (d) { applyCart(res, d); flash(btn, true); }
      else { window.location.href = '/cart'; }
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }).catch(function () { flash(btn, false); window.location.href = '/cart'; });
  });

  /* Buy now (add then checkout) */
  document.addEventListener('click', function (e) {
    var buy = e.target.closest('[data-merme-buy-now]');
    if (!buy) return;
    e.preventDefault();
    var form = buy.closest('form') || document.querySelector('[data-merme-add-form]');
    if (!form) return;
    if (form.reportValidity && !form.reportValidity()) return;
    buy.disabled = true;
    addFromForm(form).then(function () { window.location.href = '/checkout'; })
      .catch(function () { buy.disabled = false; });
  });

  /* Custom ✕ remove button in the cart drawer */
  document.addEventListener('click', function (e) {
    var x = e.target.closest('[data-mcart-remove]');
    if (!x) return;
    e.preventDefault();
    var key = x.getAttribute('data-mcart-remove');
    if (!key) return;
    x.disabled = true;
    var d = cartDrawer();
    var body = { id: key, quantity: 0 };
    if (d && d.getSectionsToRender) { body.sections = d.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        updateHeaderCount();
        if (d && d.renderContents) { d.renderContents(res); if (res.item_count === 0) d.classList.add('is-empty'); }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }).catch(function () { x.disabled = false; });
  });

  /* Expose helpers for other modules (PDP in-cart stepper) */
  window.MermeCart = {
    drawer: cartDrawer,
    apply: applyCart,
    silentUpdate: silentUpdate,
    updateHeaderCount: updateHeaderCount,
    openOnAdd: openOnAdd
  };

  /* Keep the header count in sync on ANY cart change (drawer +/-, remove, etc.) */
  function ready(fn) { (document.readyState !== 'loading') ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    updateHeaderCount();
    try {
      // PUB_SUB_EVENTS is a top-level `const` in constants.js, so it is never on window: read it by bare name.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, updateHeaderCount);
      }
    } catch (e) {}
    // fallback: observe Dawn's cart-icon-bubble count and mirror it
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && window.MutationObserver) {
      new MutationObserver(updateHeaderCount).observe(bubble, { childList: true, subtree: true });
    }
  });
})();
